import { Skeleton, Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	ACTIVE_JOURNEYS_EMPTY_HEIGHT,
	ActiveJourneysPanel,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/ActiveJourneysCard/ActiveJourneysCard.styles.tsx';
import { ActiveJourney } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/ActiveJourneysCard/ActiveJourney.tsx';
import { useInvestorJourneys } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/ActiveJourneysCard/useInvestorJourneys.ts';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	dealId: string;
	mipId: string;
	investorId: string;
}

export const ActiveJourneysCard = ({ dealId, mipId, investorId }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { journeys, isLoading, isError } = useInvestorJourneys({ dealId, mipId, investorId });

	const renderMessage = (message: string, dataTestId: string) => (
		<div className="empty" data-testid={dataTestId}>
			<Text fz={14} c="gray.6">
				{message}
			</Text>
		</div>
	);

	const renderContent = () => {
		if (isLoading) {
			return <Skeleton height={ACTIVE_JOURNEYS_EMPTY_HEIGHT} radius="0.25rem" />;
		}

		if (isError) {
			return renderMessage(
				tMipManage('investors.details.active_journeys.error'),
				TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_ERROR
			);
		}

		if (journeys.length === 0) {
			return renderMessage(
				tMipManage('investors.details.active_journeys.empty'),
				TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_EMPTY
			);
		}

		return (
			<>
				<div className="title">
					<Text fz={14} fw={600} c="white">
						{tMipManage('investors.details.active_journeys.title')}
					</Text>
				</div>

				<div className="journeys">
					{journeys.map((journey) => (
						<ActiveJourney key={journey.id} journey={journey} />
					))}
				</div>
			</>
		);
	};

	return (
		<ActiveJourneysPanel
			data-testid={TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_CARD}
		>
			{renderContent()}
		</ActiveJourneysPanel>
	);
};
